export const signalRContants = {
  LOGOUT: "Logout",
  LOAD_NOTIFICATIONS: "LoadNotifications",
  UPDATE_SUBSCRIPTION: "UpdateSubscription",
};
